import {useEffect} from 'react'
import subMonths from 'date-fns/subMonths'
import startOfDay from 'date-fns/startOfDay'
import endOfDay from 'date-fns/endOfDay'

import {dispatch, useSelector} from '../../store.js'
import {ANALYTICS_PAGE} from '../../common/constants/Pages.js'
import {setCurrentPage} from '../../redux/actions/ui/index.js'
import {
  analyticsPanelSelector,
  startDateSelector,
  endDateSelector,
} from './analyticsSelectors.js'
import {setDateRangeFilters} from './analyticsActions.js'

export default function AnalyticsLocationListener() {
  const panel = useSelector(analyticsPanelSelector)
  const startDate = useSelector(startDateSelector)
  const endDate = useSelector(endDateSelector)

  useEffect(() => {
    // panel will exist as something if the URL is on the analytics page
    if (!panel) {
      return
    }

    dispatch(setCurrentPage(ANALYTICS_PAGE))
  }, [panel])

  useEffect(() => {
    // if we came to analytics without date filters
    if (!panel || (startDate && endDate)) {
      return
    }

    const now = new Date()

    // this will cause an extra navigation, so try not to get here
    setDateRangeFilters(startOfDay(subMonths(now, 1)), endOfDay(now))
  }, [panel, startDate, endDate])

  return null
}
